import { EditionType } from '@graphics/gfx-common/dist/constants'
import {
  IDataStream,
  IDataStreamRequest,
  DataStreamForPreviewType,
  IDatafileFormInputs,
  IDataType,
} from '../types/datafile'
import { IEditionMetadata } from '../types/pack'
import { safePost, datastreamUrl, safePut, dataStreamSafePost } from './http'
import { editionsUrl } from './pack'

export const transformToDataRequest = (request: IDataStreamRequest) => {
  const instruments = [
    'isExpression',
    'isList',
    'isSymbolSet',
    'returnCurrency',
    'returnName',
    'returnNoDates',
  ]

  const transformDataTypes = (dataTypes: IDataType[]) =>
    dataTypes.map((item) => ({
      Value: item.value,
      Properties: [
        {
          Key: 'ReturnName',
          Value: item.returnName || false,
        },
      ],
    }))

  const transformDate = () => ({
    End: request.end || null,
    Frequency: request.frequency || null,
    Kind: +request.kind || 0,
    Start: request.start || null,
  })

  const transformInstrument = () => {
    const properties = instruments
      .filter((name) => request[name])
      .map((name) => ({
        Key: name,
        value: request[name] || false,
      }))
    return {
      Properties: properties || null,
      Value: request.instrument || null,
    }
  }

  return {
    DataTypes:
      request.dataTypes.length > 0
        ? transformDataTypes(request.dataTypes)
        : null,
    Date: transformDate(),
    Instrument: transformInstrument(),
    Tag: null,
  }
}

export const adaptDataForDataStream = ({
  requests,
}: IDatafileFormInputs): DataStreamForPreviewType =>
  requests.length === 1
    ? {
        DataRequest: transformToDataRequest(requests[0]),
        Properties: null,
      }
    : {
        DataRequests: requests.map(transformToDataRequest),
        Properties: null,
      }

export const defaultDatafileRequest: IDataStreamRequest = {
  instrument: '',
  kind: '1',
  frequency: 'D',
  start: '',
  end: '',
  dataTypes: [],
  isExpression: false,
  isList: false,
  isSymbolSet: false,
  returnName: false,
  returnCurrency: false,
  returnNoDates: false,
}

export const defaultDataFileFormInputs: IDatafileFormInputs = {
  title: '',
  fileName: '',
  requests: [defaultDatafileRequest],
}

export const transformToDatafileFormat = (
  { title, fileName, ...rest }: IDatafileFormInputs,
  addJSONExtensionToFileName: boolean = false
): IDataStream => ({
  editionType: EditionType.DataStreamData,
  title,
  dataStreamData: {
    fileName: addJSONExtensionToFileName ? `${fileName}.json` : fileName,
    ...rest,
  },
})

export const transformToDatafileFormInputs = (
  edition: IEditionMetadata
): IDatafileFormInputs =>
  edition.dataStreamData
    ? { ...edition.dataStreamData, title: edition.title ?? '' }
    : { title: edition.title ?? '', fileName: '', requests: [] }

export const createDataFile = (packId: string, datastream: IDataStream) =>
  safePost(editionsUrl(packId), datastream)

export const updateDataFile = (
  packId: string,
  editionId: string,
  datastream: IDataStream
) => safePut(`${editionsUrl(packId)}/${editionId}`, datastream)

export const getDataFile = (datastream: DataStreamForPreviewType) =>
  dataStreamSafePost(`${datastreamUrl}/get-data`, datastream)

export const getDataBundle = (datastream: DataStreamForPreviewType) =>
  dataStreamSafePost(`${datastreamUrl}/get-data-bundle`, datastream)
